import GARBAGE_BIN from 'assets/garbage-bin.svg';
import HEADER_BACKGROUND from 'assets/header-background.svg';

export const GarbageBin = GARBAGE_BIN;
export const JourneyHeaderBackground = HEADER_BACKGROUND;
